import { LorenzFormControl } from '@lib/forms';

export const formatBoolean = (value: boolean) => {
	return value ? 'Ja' : 'Nein';
};

// TODO Locales!
export const formatCurrency = (amount: string | number, local = 'de') => {
	const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
	const formatter = new Intl.NumberFormat(local, {
		style: 'currency',
		currency: 'EUR'
	});
	return formatter.format(numericAmount);
};

// TODO Locales!
export const formatHours = (value: unknown, local = 'de') => {
	if (value === null || value === undefined) {
		return '-';
	}

	const strValue = typeof value === 'string' ? value : String(value);

	return `${strValue.replace(/\./g, ',')} h`;
};

export const formatDate2 = (dateString: string) => {
	// Überprüfen, ob der Eingabestring im Format yyyy-mm-dd ist
	if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
		return dateString;
	}

	const [year, month, day] = dateString.split('-');
	return `${day}.${month}.${year}`;
};

// export const formatHours = (hours: number) => {
// 	const number = this.decimalPipe.transform(hours, '1.2-2', this.currentLanguage) ?? '';
// 	return number ? `${number}h` : '';
// };

export const formatNull = (formControl: LorenzFormControl | null, text = '-'): string => {
	return formControl ? formControl.value : text;
};
